const { RichText } = wp.blockEditor;

const SaveCol = ({ line, col, attributes }) => {
  const { content } = attributes;

  const tag = col === 0 ? 'h3' : 'p';
  const variant = 'text';
  const position = col === 0 ? 'left' : 'center';

  return (
    <td>
      <RichText.Content
        tagName={tag}
        className={`Typography ${variant} ${position} color-grey margin-none`}
        value={content[line]?.columns[col]}
      />
    </td>
  );
};

export default SaveCol;
